module.exports = __webpack_public_path__ + "static/autopayment_function-b3b2d342c9625f7be1f435ba7a8d045a.png";